const GraphQLForm = require('app/graphql/Form');

class Form extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitRestaurantProspectAnalyse',
            'restaurant': {'id':null,'name':null},
            'analyses': [],
            'onanalyseReady': function(analyse){},
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.onSubmit = this.onSubmit.bind(this);

        this.restaurant = this.settings.restaurant;
        this.analyses = this.settings.analyses;

        this.analyse = this.analyses.length > 0 ? this.analyses[0].node : null;

        this.buildForm();
        super.initialize();
    }

    getRestaurant(){
        return this.restaurant;
    }

    getanalyses(){
        return this.analyses;
    }

    getFirstanalyse(){
        return this.analyses.length > 0 ? this.analyses[0] : null;
    }

    getForm(){
        return this.$form;
    }

    buildForm(){
        var self = this;

        let firstanalyse = this.analyse;

        let begin = firstanalyse ? firstanalyse.analysePeriodBegin : '';
        if(begin){
            begin = moment(begin).format('YYYY-MM-DD');
        }
        let end = firstanalyse ? firstanalyse.analysePeriodEnd : '';
        if(end){
            end = moment(end).format('YYYY-MM-DD');
        }

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-info')
        .append(
            $('<i/>')
            .addClass('far fa-check-circle')
        );

        this.$form = $('<form/>')
        .addClass('restaurant-analyse-form')
        .addClass('white-box');

        let $row = $('<div/>')
        .addClass('row');

        this.$inputFrom = $('<input/>')
        .attr('id','analyseFrom')
        .attr('type','date')
        .attr('name','analysePeriodBegin')
        .addClass('form-control')
        .attr('required','required')
        .val(begin)
        .on('change',function(event){
            window.setSessionValue(self.settings.sessionFromKey,$(this).val());
        });

        $row.append(
            $('<div/>')
            .addClass('col-5 p-2')
            .append(
                $('<div/>')
                .append(
                    $('<div/>')
                    .addClass('input-group')
                    .append(
                        $('<div/>')
                        .addClass('input-group-text')
                        .append(window.translate('from'))
                    )
                    .append(this.$inputFrom)
                )
            )
        );

        this.$inputTo = $('<input/>')
        .attr('id','analyseTo')
        .attr('type','date')
        .attr('name','analysePeriodEnd')
        .addClass('form-control')
        .attr('required','required')
        .val(end)
        .on('change',function(event){
            window.setSessionValue(self.settings.sessionToKey,$(this).val());
        });

        $row.append(
            $('<div/>')
            .addClass('col-5 p-2')
            .append(
                $('<div/>')
                .append(
                    $('<div/>')
                    .addClass('input-group')
                    .append(
                        $('<div/>')
                        .addClass('input-group-text')
                        .append(window.translate('to'))
                    )
                    .append(this.$inputTo)
                )
            )
        );

        $row.append(
            $('<div/>')
            .addClass('col-2 p-2 mt-auto')
            .append(this.$btnSubmit)
        );

        this.$form
        .addClass('d-flex justify-content-center')
        .append($row);

        return this.$form;
    }

    onDOMReady(){
        if(this.analyse){
            this.$form.trigger('submit');
        }
    }

    getFields(){
        let fields = super.getFields();
        fields.push('analyse { id restaurant { id } analysePeriodBegin analysePeriodEnd }');
        return fields;
    }
    
    getVariables(){
        let variables = {};
        if(this.analyse && this.analyse.id){
            variables.id = {
                'value': this.analyse.id,
                'type': 'Int'
            };
        }
        variables.restaurant = {
            'value': this.restaurant.id,
            'type': 'Int!'
        };
        return variables;
    }


    onSuccess(data){
        this.analyse = data.analyse;
        super.onSuccess(data);
    }

}



module.exports = Form;

